import authentication from '../auth'
import Vue from 'vue'
import $ from 'jquery'

export default {
  getUserInfo () {
    var context = JSON.parse(window.localStorage.getItem('msTeamsContext'))

    var userInfoUrl = process.env.LEARN_API + '/api/teacher/v3/teams/groups?channelId=' + context.channelId
    return Vue.http.get(userInfoUrl, {headers: this.getHeaders()}).then(response => {
      return response.body
    }, response => {
      return this.getError(response, userInfoUrl)
    })
  },

  getTasks () {
    var context = JSON.parse(window.localStorage.getItem('msTeamsContext'))

    let url = process.env.LEARN_API + '/api/teacher/v3/teams/groups/' + context.channelId + '/tasks'
    return Vue.http.get(url, {headers: this.getHeaders()}).then(response => {
      return response.body
    }, response => {
      return this.getError(response, url)
    })
  },

  fetchTask (taskId) {
    let urlTask = process.env.LEARN_API + '/api/teacher/v3/teams/activities/' + taskId
    return Vue.http.get(urlTask, {headers: this.getHeaders()}).then(response => {
      return response.body
    }, response => {
      return this.getError(response, urlTask)
    })
  },

  fetchCourse (taskId, courseId) {
    let urlCourse = process.env.LEARN_API + '/api/teacher/v3/activities/' + taskId + '/courses/' + courseId + '?internalApi=true'
    return Vue.http.get(urlCourse, {headers: this.getHeaders()}).then(response => {
      return response.body
    }, response => {
      return this.getError(response, urlCourse)
    })
  },

  fetchSyllabus (syllabusId) {
    let urlSyllabus = process.env.LEARN_API + '/api/teacher/v3/curriculum/syllabuses?syllabusId=' + syllabusId
    return Vue.http.get(urlSyllabus, {headers: this.getHeaders()}).then(response => {
      return response.body
    }, response => {
      return this.getError(response, urlSyllabus)
    })
  },

  deleteGoal (activity, course, goal) {
    let urlGoalDelete = process.env.LEARN_API + '/api/teacher/v3/activities/' + activity.id + '/courses/' + course.id + '/goals/' + goal.id
    return Vue.http.delete(urlGoalDelete, {headers: this.getHeaders()}).then(response => {
      return true
    }, response => {
      return this.getError(response, urlGoalDelete)
    })
  },

  addGoal (activity, course, goal) {
    let urlGoalAdd = process.env.LEARN_API + '/api/teacher/v3/activities/' + activity.id + '/courses/' + course.id + '/goals'
    return Vue.http.post(urlGoalAdd, {goalId: goal.id}, {headers: this.getHeaders()}).then(response => {
      return goal
    }, response => {
      return this.getError(response, urlGoalAdd)
    })
  },

  removeParagraph: function (activityId, courseId, paragraphId) {
    let urlRemove = process.env.LEARN_API + '/api/teacher/v3/activities/' + activityId + '/courses/' + courseId + '/texts/' + paragraphId
    return Vue.http.delete(urlRemove, {headers: this.getHeaders()}).then(response => {
      return response.body
    }, response => {
      return this.getError(response, urlRemove)
    })
  },

  addParagraph: function (activityId, courseId, paragraphId) {
    let urlAdd = process.env.LEARN_API + '/api/teacher/v3/activities/' + activityId + '/courses/' + courseId + '/texts/' + paragraphId
    return Vue.http.post(urlAdd, {}, {headers: this.getHeaders()}).then(response => {
      return response.body
    }, response => {
      return this.getError(response, urlAdd)
    })
  },

  fetchEvaluation (taskId) {
    let urlEvaluation = process.env.LEARN_API + '/api/teacher/v3/teams/activities/' + taskId + '/evaluations'
    return Vue.http.get(urlEvaluation, {headers: this.getHeaders()}).then(response => {
      return response.body
    }, response => {
      return this.getError(response, urlEvaluation)
    })
  },

  fetchActivity (taskId) {
    let urlActivity = process.env.LEARN_API + '/api/teacher/v3/activities/' + taskId
    return Vue.http.get(urlActivity, {headers: this.getHeaders()}).then(response => {
      return response.body
    }, response => {
      return this.getError(response, urlActivity)
    })
  },

  addGrade (goal, criterion, evaluation) {
    const criterionRequest = new FormData()
    criterionRequest.append('goalId', goal.id)
    criterionRequest.append('id', criterion.id)

    var urlGradeAdd = process.env.LEARN_API + '/api/teacher/v1/evaluations/' + evaluation.id + '/grades'
    var headers = this.getHeaders()
    headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8'
    return Vue.http.post(urlGradeAdd, criterionRequest, {headers: headers}).then(response => {
      return response.body
    }, response => {
      return this.getError(response, urlGradeAdd)
    })
  },

  removeGrade (evaluation, goal) {
    var urlGradeRemove = process.env.LEARN_API + '/api/teacher/v1/evaluations/' + evaluation.id + '/grades/' + goal.id + '/delete'
    return Vue.http.post(urlGradeRemove, {evaluation: evaluation}, {headers: this.getHeaders()}).then(response => {
      return response.body
    }, response => {
      return this.getError(response, urlGradeRemove)
    })
  },

  addGradingScaleGrade (grade, evaluation) {
    const gradeRequest = new FormData()
    gradeRequest.append('id', grade.id)

    var urlGradeAdd = process.env.LEARN_API + '/api/teacher/v1/evaluations/' + evaluation.id + '/overallgrade'
    var headers = this.getHeaders()
    headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8'
    return Vue.http.post(urlGradeAdd, gradeRequest, {headers: headers}).then(response => {
      return response.body
    }, response => {
      return this.getError(response, urlGradeAdd)
    })
  },

  removeGradingScaleGrade (evaluation) {
    var urlGradeRemove = process.env.LEARN_API + '/api/teacher/v1/evaluations/' + evaluation.id + '/overallgrade'
    return Vue.http.delete(urlGradeRemove, {headers: this.getHeaders()}).then(response => {
      return response.body
    }, response => {
      return this.getError(response, urlGradeRemove)
    })
  },

  addTeachersComment (evaluationId, comment) {
    const commentRequest = new FormData()
    commentRequest.append('remark', comment)

    var urlSaveComment = process.env.LEARN_API + '/api/teacher/v1/evaluations/' + evaluationId + '/remark'
    var headers = this.getHeaders()
    headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8'
    Vue.http.post(urlSaveComment, commentRequest, {headers: headers}).then(response => {
      return response.body
    }, response => {
      return this.getError(response, urlSaveComment)
    })
  },

  lockEvaluation (evaluationId) {
    var urlLockEvaluation = process.env.LEARN_API + '/api/teacher/v3/evaluations/' + evaluationId + '/lock'
    return Vue.http.post(urlLockEvaluation, {}, {headers: this.getHeaders()}).then(response => {
      return response.body
    }, response => {
      return this.getError(response, urlLockEvaluation)
    })
  },

  unlockEvaluation (evaluationId) {
    var urlUnlockEvaluation = process.env.LEARN_API + '/api/teacher/v3/evaluations/' + evaluationId + '/unlock'
    return Vue.http.post(urlUnlockEvaluation, {}, {headers: this.getHeaders()}).then(response => {
      return response
    }, response => {
      return this.getError(response, urlUnlockEvaluation)
    })
  },

  publishEvaluation (evaluationId, publishedDate, publishDateGuardian) {
    var urlPublishEvaluation = process.env.LEARN_API + '/api/teacher/v2/evaluations/' + evaluationId + '/publish'
    return Vue.http.post(urlPublishEvaluation, {publishDate: publishedDate, publishDateGuardian: publishDateGuardian}, {headers: this.getHeaders()}).then(response => {
      return response.body
    }, response => {
      return this.getError(response, urlPublishEvaluation)
    })
  },

  unpublishEvaluation (evaluationId) {
    var urlUnPublishEvaluation = process.env.LEARN_API + '/api/teacher/v1/evaluations/' + evaluationId + '/unpublish'
    return Vue.http.post(urlUnPublishEvaluation, {}, this.getHeaders()).then(response => {
      return response.body
    }, response => {
      return this.getError(response, urlUnPublishEvaluation)
    })
  },

  getReport (evaluationId) {
    let urlEvaluation = process.env.LEARN_API + '/api/teacher/v3/teams/evaluations/' + evaluationId + '/report'
    return Vue.http.get(urlEvaluation, {headers: this.getHeaders()}).then(response => {
      return response.body
    }, response => {
      return this.getError(response, urlEvaluation)
    })
  },

  createActivity (timelineDate, headline, gradeScaleId, type, groupId, syllabusIds) {
    const activityRequest = new FormData()
    activityRequest.append('timelineDate', timelineDate)
    activityRequest.append('headline', headline)
    activityRequest.append('gradingScaleId', gradeScaleId)
    activityRequest.append('type', type)
    activityRequest.append('groupId', groupId)
    activityRequest.append('syllabusIds', syllabusIds)

    var urlCreateActivity = process.env.LEARN_API + '/api/teacher/v1/activities'
    var headers = this.getHeaders()
    headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8'
    return Vue.http.post(urlCreateActivity, activityRequest, {headers: headers}).then(response => {
      return response.body
    }, response => {
      return this.getError(response, urlCreateActivity)
    })
  },

  getGradingScales (unitId) {
    let urlGradingScale = process.env.LEARN_API + '/api/teacher/v3/gradingscales/units/' + unitId
    return Vue.http.get(urlGradingScale, {headers: this.getHeaders()}).then(response => {
      return response.body
    }, response => {
      return this.getError(response, urlGradingScale)
    })
  },

  createAssignment (activityId, groupIds, title, dueDate) {
    let urlCreateAssignment = process.env.LEARN_API + '/api/teacher/v3/activities/' + activityId + '/resources'
    return Vue.http.post(urlCreateAssignment, {groupIds: groupIds, type: 'google_assignment', title: title, dueDate: dueDate}, {headers: this.getHeaders()}).then(response => {
      return response.body
    }, response => {
      return this.getError(response, urlCreateAssignment)
    })
  },

  getError (response, url) {
    this.printError(response, url)
    if (response && response.body && response.body.errors && response.body.errors[0]) {
      return {error: this.getErrorText(response.body.errors[0])}
    } else {
      return {error: 'Something went wrong. Please report the issue'}
    }
  },

  printError (response, url) {
    let errorText = '\n'
    if (!response) {
      errorText += 'Undefined error in response from ' + url + '\n'
    } else {
      errorText += '============================' + '\n'
      errorText += 'Error in response from ' + url + '\n'
      errorText += 'Status: ' + response.status + '\n'

      if (response.body) {
        errorText += 'ErrorMessage: ' + response.body.errorMessage + '\n'
        errorText += 'Errors: ' + response.body.errors + '\n'
      }
    }
    errorText += 'Time ' + new Date() + '\n'
    errorText += '============================' + '\n'
    console.log(errorText)
  },

  getErrorText (errorCode) {
    switch (errorCode) {
      case 'ACTIVITY_DOES_NOT_EXIST':
        return 'Selected task does not exist or user does not have access to it'
      case 'EVALUATION_ID_DOES_NOT_EXIST':
        return 'Selected evaluation does not exist or user does not have access to it'
      case 'USER_DOES_NOT_EXIST':
        return 'User is not connected to the group in Plan & Assess'
      case 'GROUP_DOES_NOT_EXIST':
        return 'Group is not connected to Plan & Assess'
      case 'MORE_THAN_1_GROUP_CONNECTED':
        return 'More than one group is connected in Plan & Assess'
      case 'USER_DOES_NOT_HAVE_ACCESS_TO_GROUP':
        return 'User isn\'t connected to group in Plan & Assess '
      case 'GRADES_EXIST':
        return 'The goal has been already used for grading'
      default:
        return errorCode
    }
  },

  getHeaders () {
    return {'Authorization': 'Bearer ' + authentication.getAuthenticationToken(), 'x-tenant-id': authentication.getTenantId()}
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js